import { useGuideStore } from "@faire/retailer-visitor-shared/views/open-with-faire/academy/guidePages/useGuideStore";
import { Column } from "@faire/web--source/slate/Layout";
import React from "react";

export const ChapterColumnSEOWrapper: React.FC<React.PropsWithChildren> = ({
  children,
}) => {
  const [{ guide }] = useGuideStore(["guide"]);

  return <Column className={guide.id}>{children}</Column>;
};
